import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20abstract%20composition%20with%20flowing%20gradient%20shapes%20in%20warm%20terracotta%20orange%20and%20cream%20tones%2C%20soft%20geometric%20overlapping%20circles%20and%20curves%2C%20subtle%20texture%2C%20elegant%20contemporary%20design%2C%20digital%20media%20concept%2C%20clean%20professional%20background%20with%20warm%20organic%20shapes&width=1800&height=900&seq=hero-bg-91media&orientation=landscape"
          alt="91传媒 - 数字内容传播与媒体服务平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/25 mb-6 animate-fade-in-up">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse-subtle"></span>
          <span className="text-xs md:text-sm text-background-50 font-medium">已服务 5000+ 创作者与品牌主</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5 animate-fade-in-up animation-delay-100">
          让每一份内容
          <br />
          都<span className="text-primary-400">掷地有声</span>
        </h1>

        <p className="text-sm md:text-base text-background-300 max-w-2xl mx-auto leading-relaxed mb-8 animate-fade-in-up animation-delay-200">
          91传媒 —— 专注数字内容传播与媒体服务的综合平台。
          从内容创作到广告投放，从品牌推广到数据分析，我们为创作者与品牌主提供一站式的传媒解决方案。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-in-up animation-delay-300">
          <Link
            to="/about"
            className="px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即加入91传媒
          </Link>
          <Link
            to="/category/neirong-chuangzuo"
            className="px-7 py-3 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-sm md:text-base font-medium border border-background-50/25 hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            探索服务内容
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mt-12 md:mt-16 animate-fade-in-up animation-delay-400">
          {[
            { value: '5,000+', label: '服务创作者' },
            { value: '300+', label: '合作品牌' },
            { value: '98.5%', label: '客户满意度' },
            { value: '50亿+', label: '年内容曝光量' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-3xl font-heading font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-400 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}